'use strict';
receivableInvoicesController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'reportHelper',
	'utilsService',
	'arInvoiceService',
	'customerService',
	'siteService',
	'userService',
	'arItemService',
	'arBillingGroupService',
	'accountService',
	'authService',
	'AR_INVOICE_STATUS',
	'ACCOUNT_TYPES',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('receivableInvoicesController', receivableInvoicesController);

function receivableInvoicesController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	reportHelper,
	utilsService,
	arInvoiceService,
	customerService,
	siteService,
	userService,
	arItemService,
	arBillingGroupService,
	accountService,
	authService,
	AR_INVOICE_STATUS,
	ACCOUNT_TYPES,
	USER_CLAIMS,
	BUSY_MESSAGE,
	ROLE_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.busyPromise = $q.all([
		LoadInvoiceStatus($scope.vm),
		LoadBillingMethods($scope.vm),
		LoadBillingGroups($scope.vm),
		LoadARTerms($scope.vm),
		LoadSites($scope.vm),
		LoadARItems($scope.vm),
		LoadAllCustomers($scope.vm),
		LoadStates($scope.vm),
		LoadUsers($scope.vm),
		$scope.vm.loadInvoices(),
	]);

	function getViewModel(moduleName) {
		var now = new Date();

		var fieldClaims = authService.authentication.fieldClaims;
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'AccountsReceivableDocMgmt', USER_CLAIMS.fund, 'receivable');

		var model = {
			module: moduleName,
			busyMessage: BUSY_MESSAGE.Loading,
			accountTypeIds: ACCOUNT_TYPES,
			revenueAccountMask: null,
			invoiceStatus: [],
			billingMethods: [],
			billingGroups: [],
			arTerms: [],
			invoices: [],
			arItems: [],
			allCustomers: [],
			siteCustomers: [],
			sites: [],
			states: [],
			users: [],
			AR_INVOICE_STATUS: AR_INVOICE_STATUS,
			filter: {
				tab: 'General',
				search: '',
				statusId: null,
				propertyName: 'Id',
				reverse: false,
				fromDate: moment(now.setMonth(now.getMonth() - 2)).toDate(),
				fromDateOpen: false,
				toDate: new Date(),
				toDateOpen: false,
			},
			typeaheadLimit: 10,
			barLimit: 12,
			startIndex: 0,
			currentPageIndex: 0,
			numberOfPages: [],
			viewArInvoice: {
				images: [],
				activeImage: 0,
				confirmText: '',
				success: false,
				readOnly: false,
			},
			errors: null,
			validationErrors: null,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'ManageInvoices', 'receivable'),
			accessReceivable: true, // used by the Add Customer modal
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtDelete,
				}),
			},
		};

		function setPage(model, pageNumber) {
			if (pageNumber >= 0) {
				model.startIndex = pageNumber * model.barLimit;
			} else {
				if (model.currentPageIndex < 0) {
					model.currentPageIndex = 0;
				} else if (model.currentPageIndex > model.numberOfPages.length - 1) {
					model.currentPageIndex = model.numberOfPages.length - 1;
				}

				model.startIndex = model.currentPageIndex * model.barLimit;
			}
		}

		function showFilters(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/accountReceivable/invoice-filters-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							$scope.newFilter = angular.copy($scope.vm.filter);

							angular.extend($scope, {
								clearAll: function () {
									$scope.newFilter.customer = model.allCustomers[0];
									$scope.newFilter.site = model.sites[0];
									$scope.newFilter.user = model.users[0];
								},
								done: function () {
									if ($scope.filterForm.$valid) {
										modalInstance.close($scope.newFilter);
									}
								},
							});
						},
					],
				})
				.result.then(function (filter) {
					model.filter = filter;
					model.loadInvoices();
				});
		}

		function formIsDirty() {
			return $scope.generalForm.$dirty || $scope.otherForm.$dirty || $scope.setupForm.$dirty;
		}

		function addEditInvoice(model, invoiceId) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/accountReceivable/invoice-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					windowClass: 'app-modal-window-autoWidth',
					controller: [
						'$scope',
						'$uibModalInstance',
						'siteService',
						'arInvoiceService',
						'arItemService',
						'arBillingGroupService',
						function ($scope, modalInstance, siteService, arInvoiceService, arItemService, arBillingGroupService) {
							$scope.newInvoice = {
								AR_InvoiceLine: [],
								InvoiceDT: new Date(new Date().setHours(0, 0, 0)),
								DueDT: new Date(new Date().setHours(0, 0, 0)),
								isCustomer: true,
								isPaid: false,
								StatusId: AR_INVOICE_STATUS.Open,
								Customers: [],
							};

							if (invoiceId) {
								model.busyMessage = BUSY_MESSAGE.Loading;
								$scope.busyPromise = $q.all([getInvoice(invoiceId)]);
							} else {
								// if there is only one site, select it
								if ($scope.vm.sites && $scope.vm.sites.length === 1) {
									$scope.newInvoice.SiteId = $scope.vm.sites[0].Id;
									loadCustomers($scope.newInvoice.SiteId);
								}
							}

							$scope.$watch(
								'newInvoice.InvoiceDT',
								function (fromDT) {
									$scope.calDueDate();
								},
								true
							);

							function getInvoice(invoiceId) {
								return arInvoiceService.getInvoice(invoiceId).then(finishGettingInvoice);

								function finishGettingInvoice(response) {
									$scope.newInvoice = response.data;
									$scope.newInvoice.isCustomer = true;
									$scope.newInvoice.InvoiceDT = moment($scope.newInvoice.InvoiceDT).toDate();
									$scope.newInvoice.isPaid =
										$scope.newInvoice.StatusId === AR_INVOICE_STATUS.Paid ||
										$scope.newInvoice.StatusId === AR_INVOICE_STATUS.Closed;
									$scope.newInvoice.isPartPaid = $scope.newInvoice.StatusId === AR_INVOICE_STATUS.PartialPaid;
									$scope.calDueDate();

									$scope.loadCustomers($scope.newInvoice.SiteId);

									document.getElementById('site').autofocus = false;
									if ($scope.newInvoice.StatusId !== AR_INVOICE_STATUS.Open) {
										let elementId = model.isReadOnly ? 'doneBtn' : 'cancelBtn';
										document.getElementById(elementId).focus();
									} else {
										let elementId = model.isReadOnly ? 'doneBtn' : 'attnTo';
										document.getElementById(elementId).focus();
									}

									return angular.noop;
								}
							}

							function loadCustomers(siteId) {
								return customerService.getCustomers(siteId).then(_.partial(finishSearchingCustomers, model));

								function finishSearchingCustomers(model, response) {
									$scope.vm.siteCustomers = _.sortBy(response.data.customers, 'CustomerName');
									$scope.vm.siteCustomers = _.where($scope.vm.siteCustomers, {
										Active: 'Active',
									});

									return angular.noop;
								}
							}

							angular.extend($scope, {
								cancel: function () {
									$scope.vm.validationErrors = null;
									modalInstance.close();
								},
								addCustomer: function () {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/customer-add-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'accountStructureService',
												'customerService',
												function ($scope, modalInstance, accountStructureService, customerService) {
													$q.all([loadAccountStructures($scope.vm)]);

													function loadAccountStructures(model) {
														return accountStructureService
															.getStructure()
															.then(_.partial(finishLoadingAccountStructures, model));

														function finishLoadingAccountStructures(model, response) {
															let accountStructures = response.data.accountStructure;
															// we will only show the mask if there is a unified mask
															model.revenueAccountMask = accountStructures.UnifiedAccountMask;
															return angular.noop;
														}
													}

													angular.extend($scope, {
														cancel: function () {
															model.errors = null;
															modalInstance.close();
														},
														save: function () {
															if (!$scope.customerForm.$valid) return false;

															if ($scope.newCustomer.ReceivablesAccount) {
																$scope.newCustomer.ReceivablesAccountId = $scope.newCustomer.ReceivablesAccount.Id;
															}

															if ($scope.newCustomer.BillingMethod) {
																$scope.newCustomer.BillingMethodId = $scope.newCustomer.BillingMethod.Id;
															}
															customerService.addCustomer($scope.newCustomer).then(function (response) {
																if (response.data.isValid) {
																	modalInstance.close(response.data.customerId);
																} else {
																	$scope.errors = response.data.errors;
																}
															});
														},
													});
												},
											],
										})
										.result.then(function (customerId) {
											if (customerId) {
												$scope.getCustomer(customerId);
												$scope.invoiceForm.$setDirty();
												return;
											}
										});
								},
								addLine: function () {
									$scope.newInvoice.AR_InvoiceLine.push({
										Quantity: 1,
										Taxable: true,
									});
									$scope.vm.validationErrors = null;
								},
								removeLine: function (index) {
									$scope.newInvoice.AR_InvoiceLine.splice(index, 1);
								},
								calDueDate: function () {
									if ($scope.newInvoice.TermsId && $scope.newInvoice.InvoiceDT) {
										var terms = _.find($scope.vm.arTerms, {
											Id: $scope.newInvoice.TermsId,
										});
										if (terms) {
											$scope.newInvoice.DueDT = moment($scope.newInvoice.InvoiceDT).add(terms.Days, 'days').toDate();
										}
									}
								},
								lineAmount: function (line) {
									line.LineTotal = emsRound(line.Quantity * line.Price) || 0;
									return line.LineTotal;
								},
								taxableItemsSubTotal: function () {
									return _.reduce(
										$scope.newInvoice.AR_InvoiceLine,
										function (num, line) {
											return emsRound(num + (line.Taxable ? line.LineTotal || 0 : 0));
										},
										0
									);
								},
								calTax: function () {
									$scope.newInvoice.TotalTax =
										(($scope.taxableItemsSubTotal() || 0) + Number($scope.newInvoice.Shipping || 0)) *
										($scope.newInvoice.TaxRate / 100 || 0);
									$scope.newInvoice.TotalTax = emsRound($scope.newInvoice.TotalTax * 100) / 100;
									return $scope.newInvoice.TotalTax;
								},
								subTotal: function () {
									if (!$scope.newInvoice.AR_InvoiceLine) return 0;
									$scope.newInvoice.SubTotal = _.reduce(
										$scope.newInvoice.AR_InvoiceLine,
										function (num, line) {
											return emsRound(num + (line.LineTotal || 0));
										},
										0
									);
									return $scope.newInvoice.SubTotal;
								},
								invoiceTotal: function () {
									$scope.newInvoice.InvoiceTotal = emsRound(
										$scope.newInvoice.SubTotal + Number($scope.newInvoice.Shipping || 0) + Number($scope.newInvoice.TotalTax || 0)
									);
									return $scope.newInvoice.InvoiceTotal;
								},
								searchItemsbyItemCode: function (value) {
									return arItemService.searchARItems(value, true, $scope.vm.typeaheadLimit).then(finishSearching);

									function finishSearching(response) {
										return response.data.arItems;
									}
								},
								getItem: function (line) {
									var item = _.find($scope.vm.arItems, {
										ItemCode: line.ItemCode,
									});
									if (item) {
										line.ItemDescription = item.Description;
										line.Price = item.Price;
									}
								},
								loadCustomers: loadCustomers,
								getCustomer: function (customerId) {
									return customerService.getCustomer(customerId).then(finishLoadingCustomer);

									function finishLoadingCustomer(response) {
										if (!_.findWhere(model.siteCustomers, { Id: customerId })) {
											model.siteCustomers.push(response.data.customer);
										}
										$scope.newInvoice.Customer = response.data.customer;
										$scope.newInvoice.CustomerId = response.data.customer.Id;
										$scope.newInvoice.CustomerName = response.data.customer.CustomerName;
										$scope.newInvoice.Attention = response.data.customer.Attention;
										$scope.newInvoice.Address1 = response.data.customer.Address1;
										$scope.newInvoice.Address2 = response.data.customer.Address2;
										$scope.newInvoice.City = response.data.customer.City;
										$scope.newInvoice.State = response.data.customer.State;
										$scope.newInvoice.Zip = response.data.customer.Zip;
										$scope.newInvoice.EMail = response.data.customer.Email;
										$scope.newInvoice.Phone = response.data.customer.Phone;
										$scope.newInvoice.BillingMethodId = response.data.customer.BillingMethodId;
										$scope.newInvoice.ReceivablesAccountId = response.data.customer.ReceivablesAccountId;
										return angular.noop;
									}
								},
								setTaxable: function (line) {
									if (!line.ID || (!$scope.newInvoice.isPaid && !$scope.newInvoice.isPartPaid)) {
										line.Taxable = !line.Taxable;
									}
								},
								getBillingGroupCustomerNumber: function () {
									var billingGroup = _.findWhere($scope.vm.billingGroups, {
										Id: $scope.newInvoice.billingGroupId,
									});
									return billingGroup ? billingGroup.NumberOfCustomers : 0;
								},
								getBillingGroup: function (billGroupId) {
									$scope.newInvoice.Customers = [];
									$scope.loadingBillingGroups = arBillingGroupService
										.getARBillingGroup(billGroupId)
										.then(finishLoadingBillingGroups);

									function finishLoadingBillingGroups(response) {
										var promises = [];
										angular.forEach(response.data.arBillingGroup.AR_BillingGroupCustomer, function (customer) {
											promises.push(getBillingCustomer(customer.CustomerId));
										});
										return $q.all(promises);

										function getBillingCustomer(customerId) {
											return customerService.getCustomer(customerId).then(finishLoadingBillingCustomer);
											function finishLoadingBillingCustomer(response) {
												var hasSite = _.findWhere(response.data.customer.CustomerSites, { SiteId: $scope.newInvoice.SiteId });
												if (hasSite) {
													var customer = {
														Id: response.data.customer.Id,
														Unpaid: response.data.customer.Unpaid,
														CustomerName: response.data.customer.CustomerName,
														Attention: response.data.customer.Attention,
														Address1: response.data.customer.Address1,
														Address2: response.data.customer.Address2,
														City: response.data.customer.City,
														State: response.data.customer.State,
														Zip: response.data.customer.Zip,
														Email: response.data.customer.Email,
														Phone: response.data.customer.Phone,
														BillingMethodId: response.data.customer.BillingMethodId,
														BillingMethodDescription: response.data.customer.BillingMethodDescription,
														ReceivablesAccountId: response.data.customer.ReceivablesAccountId,
													};
													$scope.newInvoice.Customers.push(customer);
													$scope.newInvoice.Customers = _.sortBy($scope.newInvoice.Customers, 'CustomerName');
												}
												return angular.noop;
											}
										}
									}
								},
								selectCustomer: function (index) {
									$scope.selectedCustomerIndex = index;
								},
								saveInvoice: function () {
									$scope.vm.validationErrors = null;
									if (!$scope.invoiceForm.$valid) return false;

									if ($scope.newInvoice.AR_InvoiceLine.length === 0) {
										$scope.vm.validationErrors = 'You must add at least one line item.';
										return false;
									}

									if ($scope.newInvoice.Id) {
										model.busyMessage = BUSY_MESSAGE.Saving;
										$scope.busyPromise = arInvoiceService.updateInvoice($scope.newInvoice).then(finishEditInvoice);
									} else {
										var promises = [];
										$scope.newInvoice.StatusId = AR_INVOICE_STATUS.Open;
										if (!$scope.newInvoice.isCustomer) {
											angular.forEach($scope.newInvoice.Customers, function (customer) {
												var invoiceCopy = angular.copy($scope.newInvoice);

												invoiceCopy.customer = customer;
												invoiceCopy.CustomerId = customer.Id;
												invoiceCopy.CustomerName = customer.CustomerName;
												invoiceCopy.Attention = customer.Attention;
												invoiceCopy.Address1 = customer.Address1;
												invoiceCopy.Address2 = customer.Address2;
												invoiceCopy.City = customer.City;
												invoiceCopy.State = customer.State;
												invoiceCopy.Zip = customer.Zip;
												invoiceCopy.EMail = customer.Email;
												invoiceCopy.Phone = customer.Phone;
												invoiceCopy.BillingMethodId = customer.BillingMethodId;
												invoiceCopy.ReceivablesAccountId = customer.ReceivablesAccountId;

												promises.push(arInvoiceService.addInvoice(invoiceCopy));
											});
										} else {
											promises.push(arInvoiceService.addInvoice($scope.newInvoice));
										}
										model.busyMessage = BUSY_MESSAGE.Saving;
										$scope.busyPromise = $q.all(promises).then(finishEditInvoice);
									}

									function finishEditInvoice(response) {
										if (response.constructor === Array) {
											$uibModal
												.open({
													template: require('@ajs/templates/fund/accountReceivable/invoice-created-modal.html'),
													backdrop: 'static',
													keyboard: false,
													scope: $scope,
													controller: [
														'$scope',
														'$uibModalInstance',
														function ($scope, modalInstance) {
															$scope.totalInvoiceCreated = _.filter(response, function (res) {
																return res.data.isValid;
															}).length;

															$scope.totalInvoiceFaild = response.length - $scope.totalInvoiceCreated;

															angular.extend($scope, {
																done: function () {
																	modalInstance.close();
																},
															});
														},
													],
												})
												.result.then(function () {
													modalInstance.close('Added');
												});
										} else if (response.data.isValid) {
											modalInstance.close('Added');
										}
									}
								},
								sendEmail: function () {
									var arInvoicesToSend = [$scope.newInvoice.Id];

									model.busyMessage = 'Sending email ...';
									$scope.busyPromise = arInvoiceService.emailArInvoice(arInvoicesToSend).then(function (response) {
										var success = response.data.numberFailed === 0;
										$scope.vm.viewArInvoice.success = success;
										if (success) {
											$scope.vm.viewArInvoice.confirmText = '1 Invoice was emailed to customer';
										} else {
											$scope.vm.viewArInvoice.confirmText = '1 Invoice failed to be sent via email to the customer';
										}

										$uibModal.open({
											template: require('@ajs/templates/fund/accountReceivable/invoice-sendsuccess-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												function ($scope, modalInstance) {
													angular.extend($scope, {
														done: function () {
															modalInstance.close();
														},
													});
												},
											],
										});
									});
								},
								print: function () {
									var arInvoiceIdsToPrint = [invoiceId];

									reportHelper.postReport($scope, '/api/arinvoice/printarinvoice', arInvoiceIdsToPrint, 'Invoice.pdf');
								},
							});
						},
					],
				})
				.result.then(function (added) {
					if (added) {
						model.loadInvoices();
					}
				});
		}

		function loadInvoices(model) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = arInvoiceService.searchInvoices(model.filter).then(_.partial(finishLoadingInvoices, model));

			function finishLoadingInvoices(model, response) {
				model.invoices = response.data;
				return angular.noop;
			}
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		function closeInvoice(model, invoiceId) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/accountReceivable/invoice-close-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'arInvoiceService',
						function ($scope, modalInstance, arInvoiceService) {
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close(false);
								},
								closeInvoice: function () {
									$scope.closingPromise = arInvoiceService.closeInvoice(invoiceId).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											$scope.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (success) {
					if (success) {
						loadInvoices($scope.vm);
					}
				});
		}

		function searchAccountsbyAccountNumber(model, value, accountTypeId) {
			return accountService.searchAccount(accountTypeId, '', value, 8, true).then(_.partial(finishSearchAccounts, model));

			function finishSearchAccounts(model, response) {
				return response.data.accounts;
			}
		}

		return angular.extend(model, {
			setPage: _.partial(setPage, model),
			showFilters: _.partial(showFilters, model),
			formIsDirty: formIsDirty,
			addEditInvoice: _.partial(addEditInvoice, model),
			loadInvoices: _.partial(loadInvoices, model),
			sortby: _.partial(sortby, model),
			closeInvoice: _.partial(closeInvoice, model),
			searchAccountsbyAccountNumber: _.partial(searchAccountsbyAccountNumber, model),
		});
	}

	function LoadBillingMethods(model) {
		return utilsService.getBillingMethods().then(_.partial(finishLoadingBillingMethods, model));

		function finishLoadingBillingMethods(model, response) {
			model.billingMethods = response.data.billingMethods;
		}
	}

	function LoadBillingGroups(model) {
		return arBillingGroupService.getARBillingGroups().then(_.partial(finishLoadingBillingGroups, model));

		function finishLoadingBillingGroups(model, response) {
			model.billingGroups = _.filter(response.data.arBillingGroups, function (item) {
				return item.NumberOfCustomers > 0;
			});
		}
	}

	function LoadARTerms(model) {
		return utilsService.getARTerms().then(_.partial(finishLoadingARTerms, model));

		function finishLoadingARTerms(model, response) {
			model.arTerms = response.data;
		}
	}

	function LoadInvoiceStatus(model) {
		return utilsService.getARInvoiceStatus().then(_.partial(finishLoadingInvoiceStatus, model));

		function finishLoadingInvoiceStatus(model, response) {
			model.invoiceStatus = response.data.invoiceStatus;
			model.invoiceStatus.unshift({
				Description: 'Open / Partial paid',
				Id: [1, 2],
			});
			model.invoiceStatus.unshift({ Description: 'All', Id: null });
		}
	}

	function LoadARItems(model) {
		return arItemService.getARItems().then(_.partial(finishLoadingItems, model));

		function finishLoadingItems(model, response) {
			model.arItems = response.data.arItems;
			return angular.noop;
		}
	}

	function LoadAllCustomers(model) {
		return customerService.getCustomers().then(_.partial(finishLoadingCustomers, model));

		function finishLoadingCustomers(model, response) {
			model.allCustomers = response.data.customers;
			model.allCustomers.splice(0, 0, { CustomerName: 'All Customers' });
			model.filter.customer = model.allCustomers[0];

			return angular.noop;
		}
	}

	function LoadSites(model) {
		return siteService.getSites().then(_.partial(finishedLoadingSites, model));

		function finishedLoadingSites(model, response) {
			model.sites = response.data.sites;
			model.sites.splice(0, 0, { SiteName: 'All Sites' });
			model.filter.site = model.sites[0];
			return angular.noop;
		}
	}

	function LoadStates(model) {
		return utilsService.getStates().then(_.partial(finishLoadingStates, model));

		function finishLoadingStates(model, response) {
			var country = _.find(response.data.states, function (c) {
				if (c.CountryCode === 'US') {
					return c;
				}
			});

			model.states = country.StateCodes;
		}
	}

	function LoadUsers(model) {
		return userService.list().then(_.partial(finishLoadingUsers, model));

		function finishLoadingUsers(model, response) {
			model.users = response.data.users;
			model.users.splice(0, 0, { UserName: 'All Users' });
			model.filter.user = model.users[0];
		}
	}
}
